module.exports = __webpack_public_path__ + "static/media/cancel.545b5526.svg";